import { Button, CircularProgress, IconButton, Skeleton, useMediaQuery } from '@mui/material'
import { Image, Input } from 'antd'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { createRef, useEffect, useRef, useState } from 'react'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';
import axios from 'axios';
import { io } from 'socket.io-client';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import ForwardIcon from '@mui/icons-material/Forward';
import RedoIcon from '@mui/icons-material/Redo';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import TextArea from 'antd/es/input/TextArea';


import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import {motion} from "framer-motion"
import { highlightWords } from 'react-highlight-words';
import { scrollIntoView } from 'react-scroll-into-view';
const socket = io(process.env.REACT_APP_URL);


const generateRandomString = () => {
    const length = 25; // Change this to the desired length of the random string
    const randomCharacters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    let randomString = '';
    for (let i = 0; i < length; i++) {
      randomString += randomCharacters[Math.floor(Math.random() * randomCharacters.length)];
    }

    return randomString;
  };

export default function EachMessaages({latestMessage,handleLatestMessage,userData,data,ActiveShope,AllChats,GetAllChats,handleOnline,online,unread,setReplayinggMessageContent,setIsCopied}){
    const [anchorEl, setAnchorEl] = useState(null);
    const [isSeen, setIsSeen] = useState(data?.isSeen);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
 const messageRef = useRef(null);
  
  const ITEM_HEIGHT = 48;
  
  let [option,setOption]=useState([
        {icon:<EditIcon style={{fontSize:"13px"}}/>,value:"Edit",id:1},
        {icon:<RedoIcon style={{fontSize:"12px"}}/>,value:"Replay",id:2},
        {icon:<ContentCopyIcon style={{fontSize:"12px"}}/>,value:"Copy",id:3},
        {icon:<DeleteIcon style={{fontSize:"12px"}}/>,value:"Delete",id:4},
          
    ])
    useEffect(()=>{

    if(data?.sender?._id!==ActiveShope&&(data?.audio?.fileUrl||data?.image?.fileUrl)){
        setOption([
                {icon:<RedoIcon style={{fontSize:"12px"}}/>,value:"Replay",id:2},
                {icon:<DownloadIcon style={{fontSize:"12px"}}/>,value:"Download",id:5},
            ])
       }

    else if(data?.sender?._id!==ActiveShope){
        setOption([
                {icon:<RedoIcon style={{fontSize:"12px"}}/>,value:"Replay",id:2},
                {icon:<ContentCopyIcon style={{fontSize:"12px"}}/>,value:"Copy",id:3},
            ])
     }

     else if(data?.audio?.fileUrl||data?.image?.fileUrl){
      setOption([
            {icon:<RedoIcon style={{fontSize:"12px"}}/>,value:"Replay",id:2},
            {icon:<DeleteIcon style={{fontSize:"12px"}}/>,value:"Delete",id:4},
            {icon:<DownloadIcon style={{fontSize:"12px"}}/>,value:"Download",id:5},
        ])
     }
    
    },[data])


    let [isEditing,setIsEditing]=useState(false)
    let [content,setContent]=useState(data?.content)
    let [editingValue,setEditingValue]=useState(content||"")
  

    function handleClose(id){
          setAnchorEl(null);
        if(id===1) {
         // alert("delete text")
          setIsEditing(true)
        }
        if(id===2){
       //   alert(`Replayid for ${content||(data?.audio?"Audio file":"Image file")}`)
          setReplayinggMessageContent(data)
        }
        if(id===3){
              copyTextToClipboard(content)
              .then(() => {
                // If successful, update the isCopied state value
                setIsCopied(true);
                setTimeout(() => {
                  setIsCopied(false);
                }, 1500);
              })
              .catch((err) => {
                console.log(err);
              });
        }

        if(id===4){
          setIsLoading(true)
          axios.put(`${process.env.REACT_APP_URL}/api/messages/Deletemessage`,{messageId:data?._id,content:editingValue,ActiveShope:ActiveShope}, //proxy uri
          {
            headers: {
                authorization:`Bearer ${ userData?.token }`,
                'Content-Type': 'application/json'
            } 
          })
          .then(res=>{
            console.log(res.data);
            setIsLoading(false)
            
            let flteredMessage=AllChats.filter(e=>{
              return e._id!==data?._id
            })
         
            GetAllChats(flteredMessage)
          })
          .catch(error=>{
           console.log(error);
            setIsLoading(false)
            
          })
        }

        if(id===5){
          //alert("Downloading file")
          //console.log(generateRandomString());
           if(data?.image||data?.audio){
            let fileLink=data?.image?.fileUrl||data?.audio?.fileUrl
            fetch(fileLink)
            .then(response => response.blob())
            .then(blob => {
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              let file_name=data?.image?`${generateRandomString()}.jpg`:`${generateRandomString()}.mp3`
              link.setAttribute('download', file_name);
              link.click();
            });
           }
        }
      
      }
      // This is the function we wrote earlier
      async function copyTextToClipboard(text) {
        if ('clipboard' in navigator) {
          return await navigator.clipboard.writeText(text);
        } else {
          return document.execCommand('copy', true, text);
        }
      }
    
    
    let[isLoading,setIsLoading]=useState(false)
    let[editingFinished,setEditingFinished]=useState(false)
   
    const DonEditing=()=>{
      setIsLoading(true)
      axios.put(`${process.env.REACT_APP_URL}/api/messages/UpdateMessage`,{messageId:data?._id,content:editingValue,ActiveShope:ActiveShope}, //proxy uri
      {
        headers: {
            authorization:`Bearer ${ userData?.token }`,
            'Content-Type': 'application/json'
        } 
      })
      .then(res=>{
       // console.log(res.data);
        setContent(editingValue)
        setIsEditing(false)
        setIsLoading(false)
        setEditingFinished(true)
        
        //console.log(values);
        let latestMessageForThatChat=latestMessage.filter(e=>{
           return e?._id===data?._id
        })
        console.log(latestMessageForThatChat,data);
        if(latestMessageForThatChat.length>0){
           handleLatestMessage(element=>element.map(e=>{
             return  e?._id===data?._id?{...e,content:editingValue}:{...e}
           }))
        }
        
      })
      .catch(error=>{
        console.log(error);
        setIsLoading(false)
        setEditingValue(content)
        
      })

    }
  
  
    let [scroly,setScroly]=useState(0)
     useEffect(()=>{
      function handleScroll(){
        setScroly(window.scrollY) 
     } 
     window.addEventListener("scroll",handleScroll)
     },[scroly])
  
    
    let[equi,habdle_equi]=useState(0)
    const [repliedMessageClicked,handleRepliedMessageClicked]=useState(false)

    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          if(!isSeen){
            socket.emit('message seen', data,ActiveShope,isSeen);
         //   console.log("see red",ActiveShope,data.content);
            setTimeout(()=>{
              habdle_equi(equi+2)
            },3000)
            
          }
        //  console.log(data.sender._id,ActiveShope);
          if(data.sender?._id!==ActiveShope){
          axios.put(`${process.env.REACT_APP_URL}/api/messages/updateUnreadMessage`,{messageId:data?._id,ActiveShope:ActiveShope}, //proxy uri
          {
            headers: {
                authorization:`Bearer ${ userData?.token }`,
                'Content-Type': 'application/json'
            } 
          })
          .then(res=>{
            //console.log(res.data);
          })
          .catch(error=>{
            //console.log(error);
          })
        }
        unread.handleFlagUnread([])
         unread.handleControlUnread(unread.controlUnread+2)
         handleRepliedMessageClicked(false)
        }
      });
  
      if (messageRef.current) {
        observer.observe(messageRef.current);
      }
  
      return () => {
        if (messageRef.current) {
          observer.unobserve(messageRef.current);
        }
      };
    },[scroly,data,AllChats]);
  
  
      useEffect(() => {
        socket.on("update message status", (message) => {
           //console.log(message.content,data.content,isSeen);
           if(message){
                let messageData={
                  messageId:data._id
                }
                setIsSeen(true)
                axios.put(`${process.env.REACT_APP_URL}/api/messages/MessageSeen`,messageData, //proxy uri
                  {
                    headers: {
                        authorization:`Bearer ${ userData?.token }`,
                        'Content-Type': 'application/json'
                    } 
                  })
                  .then(res=>{
                  })
                  .catch(error=>{
                    //console.log(error);
                  })
                
           }
        });
      },[equi])
      
      
    return(
      <motion.div 
        initial={{ opacity: 0, x:ActiveShope===data?.sender?._id?-100:100 }}
        whileInView={{ opacity: 1,x:0}}
        transition={{ duration: 0.4 }}
       ref={messageRef} className={`eachChat-allMessages-each ${(ActiveShope===data?.sender?._id||data?.isLoading)&&"eachChat-allMessages-each-sender"}`}>
         <IconButton
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? 'long-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={handleClick}
                            style={{fontSize:"10px",width:"10px",height:"1px",marginBottom:"2px"}}
                          >
                            <MoreVertIcon className='chatMessage-icon'/>
          </IconButton>
  
         <div className={`eachChat-allMessages-each-body ${(ActiveShope===data?.sender?._id||data?.isLoading)&&"eachChat-allMessages-each-body-sender"} ${!data?.content&&"eachChat-allMessages-each-body-noText"}`}>
    
             <>
              <Menu
                              id="long-menu"
                              MenuListProps={{
                                'aria-labelledby': 'long-button',
                              }}
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              PaperProps={{
                                style: {
                                  maxHeight: ITEM_HEIGHT * 4.5,
                                  width: '15ch',
                                },
                              }}
                            >
                              {option.map((option,index) => (
                                <MenuItem key={index} onClick={()=>handleClose(option.id)}>
                                   <div style={{display:"flex",alignItems:"center",gap:"3px"}}>
                                      {option.icon}
                                      <div style={{fontSize:"13px"}}>{option.value}</div>

                                   </div>
                                </MenuItem>
                              ))}
                  </Menu>
                
                <div className='eachChat-allMessages-each-body-text'>
                  {data?.repliedFor?._id&&
                    <div className='eachChat-allMessages-each-body-text-replied' >
                       <div className='eachChat-allMessages-each-body-text-replied-by'><RedoIcon style={{fontSize:"12px",color:"black",paddingRight:"5px"}}/>{data?.repliedFor?.sender?.shope_name}</div>
                      <div className='eachChat-allMessages-each-body-text-replied-text'>
                          {data?.repliedFor?.content?.length>50?`${data?.repliedFor?.content.slice(0,50)}...`:data?.repliedFor?.content}
                          {data?.repliedFor?.image&& "Image File"}
                          {data?.repliedFor?.audio&&"Audio File"}
                      </div>
                   </div>}
                  {isEditing?
                    <>
                     {isLoading?
                       <CircularProgress size={25}/>
                      :<span >
                        <TextArea
                          autoFocus={true}
                          autoSize={{
                                        minRows:1,
                                        maxRows: 2,
                                      }} 
                                  value={editingValue} onChange={(e)=>setEditingValue(e.target.value)} 
                                />
                        <div style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}>
                              <div><IconButton onClick={()=>setIsEditing(false)}><CloseIcon style={{color:"red",fontSize:"20px"}}/></IconButton></div>
                              <div><IconButton onClick={DonEditing}><DoneIcon style={{color:"black",fontSize:"20px"}}/></IconButton></div>
                        </div>
                      </span>}
                    </>
                     :
                    <span>{content&&content}</span>
                   }
                  {data?.image&&<Image src={data?.image?.fileUrl} height={200} width={"100%"}/>}
                  {data?.audio&&<audio src={data?.audio?.fileUrl}  controls></audio>}
                </div>
                
                <div className={`eachChat-allMessages-each-body-date ${(data.isEdited||editingFinished)&&"eachChat-allMessages-each-body-date-edited"}`}>
                  {data?.isLoading?
                    <><AccessTimeFilledIcon style={{fontSize:"12px"}}/></>
                    :
                  <>
                    {(data?.sender?._id?.toString()===ActiveShope)&&<div>{isSeen?<VisibilityIcon style={{fontSize:"11px",marginTop:"4px"}}/>:<VisibilityOffIcon style={{fontSize:"11px"}}/>}</div>}
                    <div>{moment(data?.createdAt).calendar()}</div>
                  </>
                }
              </div>
             </>
             
          </div>
      </motion.div>
    )
  }


  
  /*
     console.log(flteredMessage);
            let latestMessageForThatChat=latestMessage.filter(e=>{
              return e?._id===data?._id
           })
           if(latestMessageForThatChat.length>0){
              let relevantMessage = flteredMessage.length > 0 ? flteredMessage[flteredMessage.length - 1] : null;
              const noMessageExist = {
                chat: latestMessageForThatChat[0].chat,
                sender:latestMessageForThatChat[0].sender,
                isDeleted: true,
                content: 'Messages Deleted!',
                deletedFrom:[],

              };

              latestMessageForThatChat = relevantMessage || noMessageExist;

              handleLatestMessage(element=>element.map(e=>{
                return e?._id===data?._id?
                            {chat:latestMessageForThatChat.chat,
                              sender:latestMessageForThatChat.sender,
                              content:latestMessageForThatChat?.content,
                              image:latestMessageForThatChat?.image,
                              audio:latestMessageForThatChat?.audio,
                              deletedFrom:latestMessageForThatChat.deletedFrom,
                            
                            }:{...e}
              }))
           }
  */